import React from "react"
import { Button } from "react-bootstrap"
import "./winpebtnstyle.css"
import PropTypes from "prop-types"

export default class WinpeBtn extends React.Component {
	render () {
		const { title, onClick } = this.props
		return (
			<Button onClick={onClick} className="btn btn-default winpe__btn">
				{title}
			</Button>
		)
	}
}

WinpeBtn.propTypes = {
	title: PropTypes.string,
	onClick: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/WinpeButton.js